var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tracks.length > 0 && _vm.visible),expression:"tracks.length > 0 && visible"}],ref:"container"})}
var staticRenderFns = []

export { render, staticRenderFns }